import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { NotificationTypeUserConfigurationClient, NotificationTypeUserConfigurationView } from './api-proxies';

@Injectable({
    providedIn: 'root'
})
export class NotificationTypeUserConfigurationService {
    constructor(private readonly client: NotificationTypeUserConfigurationClient) {}

    async save(body: NotificationTypeUserConfigurationView[]): Promise<NotificationTypeUserConfigurationView[]> {
        return await lastValueFrom(this.client.notificationTypeUserConfigurationSave(body));
    }

    async getUserConfigurations(): Promise<NotificationTypeUserConfigurationView[]> {
        return await lastValueFrom(this.client.notificationTypeUserConfigurationGetForCurrentUser());
    }
}
